"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInputWithIcon = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var Flex_1 = require("../Flex");
var theme_1 = require("../theme");
var StyledInput = styled_1.default.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", " ", " ", "\n    ", ";\n  font-size: ", ";\n  background-color: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  display: inline-block;\n  outline: none;\n  line-height: ", ";\n  width: 100%;\n  color: ", ";\n\n  &:hover:enabled {\n    border-color: ", ";\n  }\n\n  &:focus {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n"], ["\n  padding: ", " ", " ", "\n    ", ";\n  font-size: ", ";\n  background-color: ", ";\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  display: inline-block;\n  outline: none;\n  line-height: ", ";\n  width: 100%;\n  color: ", ";\n\n  &:hover:enabled {\n    border-color: ", ";\n  }\n\n  &:focus {\n    outline: 2px solid ", ";\n    outline-offset: 2px;\n  }\n"])), theme_1.theme.space.space8, theme_1.theme.space.space16, theme_1.theme.space.space8, theme_1.theme.space.space40, theme_1.theme.fontSizes.fontsize16, theme_1.theme.colors.surface200, theme_1.theme.colors.contentPrimary, theme_1.theme.colors.n80, theme_1.theme.radii.field, theme_1.theme.lineHeights.lineheight16, theme_1.theme.colors.contentPrimary, theme_1.theme.colors.n300, theme_1.theme.colors.borderPrimary);
var TextInputWithIcon = function (_a) {
    var icon = _a.icon, placeholder = _a.placeholder, value = _a.value, onChange = _a.onChange, props = __rest(_a, ["icon", "placeholder", "value", "onChange"]);
    return (react_1.default.createElement(Flex_1.Flex, { gap: 'space16' },
        react_1.default.createElement(Flex_1.Flex, { position: 'absolute', paddingTop: 'space8', paddingLeft: 'space12', paddingRight: 'space12' }, icon),
        react_1.default.createElement(StyledInput, __assign({ placeholder: placeholder, type: "text", value: value, onChange: onChange }, props))));
};
exports.TextInputWithIcon = TextInputWithIcon;
var templateObject_1;
//# sourceMappingURL=index.js.map